<div class="d-flex flex-row justify-content-between">
  <div class="flex-wrap align-items-center">
    <h2 class="titulos ml-5">Marcas</h2>
  </div>
</div>
<hr class="ml-5 bg-naranja full-width" style="height: 2px;">
<div class="d-flex flex-wrap flex-row justify-content-start align-items-center">
  <ng-container *ngFor="let marca of marcas">
    <div class="mt-1 ml-5 mr-5 mb-5">
      <a [routerLink]="['','productos']" [queryParams]="{marca:marca.fab_codigo}">
        <span class="icon-foto" *ngIf="(marca.descripcion_publicidad && marca.descripcion_publicidad!='')">
          <i class="fas fa-info-circle" style="font-size: 1.7em" aria-hidden="true"></i>
        </span>
        <img [src]="marca.img" [alt]="marca.fab_codigo" width="150" [title]="marca.marca">
      </a>
    </div>
  </ng-container>
</div>
